import React from 'react'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/'

import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import T from 'components/FormattedMessage'

const styles = (theme: Theme) => createStyles({
  root: {
    '& a': {
      color: theme.palette.primary.main,
    },
  },
})

type InjectedProps = CheckboxProps & WithStyles<typeof styles>

const OnboardingPrivacyCheckbox: React.SFC<InjectedProps> = ({ classes, ...props }) => {
  return (
    <FormControlLabel
      className={classes.root}
      control={
        <Checkbox
          value="isPolicyAccepted"
          color="primary"
          required
          {...props}
        />
      }
      label={<T id="onboarding_privacypolicyagreement" markdown />}
    />
  )
}

export default withStyles(styles)(OnboardingPrivacyCheckbox)
